import React from 'react';
import PropTypes from 'prop-types';

const LoyaltyIdInput = ({ value, onChange }) => {
    if (!Mobi2Go.headoffice.customer_loyalty_scheme_name) {
        return null;
    }
    return (
        <div
            data-loyalty-id
            data-icon-before
            className="m2g-input-container m2g-form-element--full-width"
        >
            <input
                type="tel"
                className="m2g-customer-loyalty-input m2g-input m2g-form-element--full-width"
                placeholder={Mobi2Go.headoffice.customer_loyalty_scheme_name}
                title={Mobi2Go.headoffice.customer_loyalty_scheme_name}
                value={value}
                onChange={e => onChange(e.target.value)}
            />
            <span className="m2g-icon" style={{ fontWeight: 'bold' }}>
                #
            </span>
        </div>
    );
};

LoyaltyIdInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default LoyaltyIdInput;
